// extracted by mini-css-extract-plugin
module.exports = {"center":"Loading2_center__1YHcO","center2":"Loading2_center2__sdHqM","ring":"Loading2_ring__3VPQb","ring2":"Loading2_ring2__iAODd"};